module.exports = __webpack_public_path__ + "static/assets/2e6994cc7c70b524c649f60346bdcb3a.woff2";